export const syncStatus = {
  new: 'Новый',
  error: 'Ошибка',
  sending: 'Отправляется',
  sent: 'Отправлен',
  completed: 'Завершён',
  processing: 'В обработке',
};

export default {};
